import { render, staticRenderFns } from "./NewPlagueMonitoring.vue?vue&type=template&id=643b2cf3&scoped=true&lang=html&"
import script from "./NewPlagueMonitoring.vue?vue&type=script&lang=js&"
export * from "./NewPlagueMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b2cf3",
  null
  
)

export default component.exports